import React, { useEffect } from 'react';
import { FieldError, get, useFormContext } from 'react-hook-form';
import css from '../index.module.css';

interface FieldProps {
  name: string;
  children: React.ReactNode;
}

const Field: React.FC<FieldProps> = ({ name, children }) => {
  const {
    formState: { errors },
    trigger,
  } = useFormContext();
  const error = get(errors, name);

  useEffect(() => {
    trigger(name).catch(() => {});
  }, [name, trigger]);

  return (
    <div className={`${css['form-field']} ${error ? css['error'] : ''}`}>
      {children}
      {error &&
        (Array.isArray(error) ? (
          error.map((err, index) => <Error key={index} error={err} />)
        ) : (
          <Error error={error as FieldError} />
        ))}
    </div>
  );
};

interface ErrorProps {
  error: FieldError | string;
}
const Error: React.FC<ErrorProps> = ({ error }) => (
  <div className="text-error">
    {(error as FieldError)?.message || String(error)}
  </div>
);

export default Field;
